import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { bnnList, Com0102CtlBnnOut } from 'app/core/models/api/com/com0102'
import { Dep0103CtlrOut } from 'app/core/models/api/dep/dep0103'
import { selectBannerCom0102 } from 'app/core/services/com/com.service'
import { selectDep0103 } from 'app/core/services/prd/dep.service'
import { RootState } from 'app/core/store'
/**
 * Banner에 사용되는 데이터를 보관한다.
 * /prd/com/com01/com0102호출 결과물을 날짜와 종류로 구분한 것이다.
 */
type banners = {
    main: bnnList[]
    product: bnnList[]
}
const initialState: banners = {
    main: [],
    product: [],
}

const slice = createSlice({
    name: 'banners',
    initialState,
    reducers: {
        clear: (state) => {
            state = initialState
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            selectBannerCom0102.matchFulfilled,
            (state, action) => {
                //API가 성공하면 가로채 넣는다.
                const fullData = { ...action.payload }
                const banners = fullData.data
                const main: bnnList[] = []
                const product: bnnList[] = []
                banners?.forEach((item, index) => {
                    //TODO: 시간 필터링 추가 필요. 시간은 어느 시점에 가져오나?
                    if (item.bnnrTcd === '01') {
                        main.push(item)
                    } else if (item.bnnrTcd === '02') {
                        product.push(item)
                    }
                })
                state.main = main
                state.product = product
            }
        )
    },
})

export const { clear } = slice.actions

export const selectorMainBanner = (state: RootState) => {
    return state.banners.main
}

export const selectorProductBanner = (state: RootState) => {
    return state.banners.product
}

export default slice.reducer
